export default __webpack_public_path__ + "static/media/06 - Document and Image Viewer.7e6cf002.png";